import React from 'react';
import './Products.css';
import ProductListAnimals from './ProductListAnimals';
import ProductListBirds from './ProductListBirds';
import ProductListGnomes from './ProductListGnomes';
import ProductListFlowers from './ProductListFlowers';
import ProductListChristmas from './ProductListChristmas';

import {
    CardAnimalImages,
    CardBirdImages,
    CardGnomeImages,
    CardChristmasImages,
    MagnetAnimalImages,
    MagnetBirdImages,
    MagnetGnomeImages,
    CoasterAnimalImages,
    CoasterBirdImages,
    CoasterGnomeImages,
    BookmarkBirdImages,
    BookmarkFlowerImages,
    ClipAnimalImages,
    ClipBirdImages,
    ClipFlowerImages,
    ClipGnomeImages,
    PenAnimalImages,
    PenBirdImages,
    PenFlowerImages,
    PenGnomeImages,
    StubbyAnimalImages,
    StubbyGnomeImages,
} from '../../assets/products/index';

import { ProductCard } from '../../components';

const Products = (props) => {
    let Images = new Object();

    let AnimalImages = [],
        BirdImages = [],
        GnomeImages = [],
        FlowerImages = [],
        ChristmasImages = [];

    switch (props.prefix) {
        case 'M':
            AnimalImages = MagnetAnimalImages;
            BirdImages = MagnetBirdImages;
            GnomeImages = MagnetGnomeImages;
            break;
        case 'G':
            AnimalImages = CardAnimalImages;
            BirdImages = CardBirdImages;
            GnomeImages = CardGnomeImages;
            ChristmasImages = CardChristmasImages;
            break;
        case 'C':
            AnimalImages = CoasterAnimalImages;
            BirdImages = CoasterBirdImages;
            GnomeImages = CoasterGnomeImages;
            break;
        case 'B':
            BirdImages = BookmarkBirdImages;
            FlowerImages = BookmarkFlowerImages;
            break;
        case 'CL':
            AnimalImages = ClipAnimalImages;
            BirdImages = ClipBirdImages;
            FlowerImages = ClipFlowerImages;
            GnomeImages = ClipGnomeImages;
            break;
        case 'P':
            AnimalImages = PenAnimalImages;
            BirdImages = PenBirdImages;
            FlowerImages = PenFlowerImages;
            GnomeImages = PenGnomeImages;
            break;
        case 'S':
            AnimalImages = StubbyAnimalImages;
            GnomeImages = StubbyGnomeImages;
            break;
    }

    AnimalImages.map((product) => {
        product.name = ProductListAnimals.find(
            (drawing) => drawing.ID === product.ID
        ).name;

        product.prefix = props.prefix + 'A';
        return product;
    });

    BirdImages.map((product) => {
        product.name = ProductListBirds.find(
            (drawing) => drawing.ID === product.ID
        ).name;

        product.prefix = props.prefix + 'B';
        return product;
    });

    GnomeImages.map((product) => {
        product.name = ProductListGnomes.find(
            (drawing) => drawing.ID === product.ID
        ).name;

        product.prefix = props.prefix + 'G';
        return product;
    });

    FlowerImages.map((product) => {
        product.name = ProductListFlowers.find(
            (drawing) => drawing.ID === product.ID
        ).name;

        product.prefix = props.prefix + 'F';
        return product;
    });

    ChristmasImages.map((product) => {
        product.name = ProductListChristmas.find(
            (drawing) => drawing.ID === product.ID
        ).name;

        product.prefix = props.prefix + 'X';
        return product;
    });

    Images = BirdImages.concat(AnimalImages)
        .concat(ChristmasImages)
        .concat(FlowerImages)
        .concat(GnomeImages);

    let color_light = 'hsla(' + props.theme + ',28%,100%)';

    return (
        <main className='Products'>
            <div
                className='Products__Container'
                style={{
                    backgroundColor: 'hsla(var(--color-bg), 30%)',
                }}
            >
                <div className='Products__HeadingContainer'>
                    <div className='Products__HeadingContent'>
                        <div
                            className='Products__HeadingMain'
                            style={{
                                background: color_light,
                                color: 'white',
                            }}
                        >
                            <div>
                                <h1>{props.products}</h1>
                                <br></br>
                                <h3>{props.size}</h3>
                            </div>

                            <h2
                                className='Products__HeadingCost'
                                style={{
                                    background: 'hsl(' + props.theme + ', 45%)',
                                    boxShadow:
                                        '0 0.25rem 0.5rem hsla(' +
                                        props.theme +
                                        ', 10%, 0.4)',
                                }}
                            >
                                {props.cost}
                            </h2>
                        </div>
                        <div
                            className='Products__HeadingDescription'
                            style={{
                                borderTop: '1px solid black',
                            }}
                        >
                            <ul>
                                <li>
                                    All {props.products} are from original
                                    drawings by Daniela Pessotto-Robba.
                                </li>
                                {props.extra}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='Products__CardGridContainer'>
                    <div
                        className='Products__CardGrid'
                        style={{
                            gridTemplateColumns:
                                'repeat(auto-fit, minmax(' +
                                props.productWidth +
                                ', auto))',
                        }}
                    >
                        {Images.map((product) => (
                            <ProductCard
                                key={product.ID}
                                prefix={product.prefix}
                                ID={product.prefix + String(product.ID)}
                                products={props.products}
                                product={product}
                                borderRadius={props.borderRadius}
                                theme={props.theme}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Products;
